export default {
  menuItems: [
    {
      name: 'Projekty',
      permission:'projects_access',
      route: 'PlatformProjects'
    },
    {
      name: 'Ankiety',
      permission:'surveys_access',
      route: 'PlatformSurveys'
    },
    {
      name: 'Czarna Lista',
      permission:'blacklist_access',
      route: 'PlatformBlacklist'
    },
    {
      name: 'Książka adresowa',
      permission:'address_book_access',
      route: 'PlatformAddressBook'
    },
    {
      name: 'Call Planner',
      permission:'callplanner_menu_access',
      route: 'PlatformCallPlanner'
    },
    {
      name: 'Raporty',
      permission:'reports_access',
      route: 'PlatformReports'
    },
    { 
      name: 'Kampanie wychodzące',
      permission: 'campaigns_access',
      route: 'PlatformCampaigns'
    }
  ]
}